export default {
  'standard-phone': 375,
  'large-phone': 440,
  'small-tablet': 600,
  'tablet': 768,
  'medium-tablet': 800,
  'large-tablet': 920,
  'desktop': 1024,
  'medium-desktop': 1280,
  'large-desktop': 1400,
  'xlarge-desktop': 1620,
  'desktop-nav': 1050,
};